import { Component, OnInit, HostBinding, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { DataService } from '../../_services/data.service';
import { Router, ActivatedRoute, NavigationEnd, Routes } from '@angular/router';
// import { AuthService } from '../../_services/auth.service';
// import { trigger, state, transition, animate, style } from '@angular/animations';
import { anim, slideRight, slideUp } from 'src/app/animations';
import { Title } from '@angular/platform-browser';
import { FlatPropertiesTestComponent } from '../buildings/flat-properties-test/flat-properties-test.component';
import { Location } from '@angular/common';
import { HowMuchRoomsComponent } from '../buildings/how-much-rooms/how-much-rooms.component';
import { ThreejsComponent } from '../threejs/threejs.component';
import { WindRoseComponent } from '../wind-rose/wind-rose.component';



@Component({
  selector: 'app-project-light',
  templateUrl: './project-light.component.html',
  // host: {'class': 'someClass1'},
  styleUrls: ['./project-light.component.scss'],
  animations: [
    slideRight, slideUp
  ],
  host: {
    '[@slideRight]': 'condition',
    'class': 'light-version'
  }
})
export class ProjectLightComponent implements OnInit {

 // @HostBinding('@anim')
 showComponents: boolean = false;
 currentBuilding: {};
 currentRoomAmount: any;
 flatStatusClass: string;
 desktopResolution: boolean = true;
 showBuilding: boolean = false;
 moveBuildingMenuFull: boolean = false;
 // moveBuildingMenuHalf: boolean = false;
 flat: any;
 showBuildings: boolean = false;
 iframeElement: any;
 removeCloseButton: boolean = false;
 showProject: boolean = true;
 message: any = "";
 withBuilding: boolean = false;
 curSceneName: string = '';
 sceneTitleArray: [] = [];
 activateRose: boolean = true;
 refresh: boolean = true;
 buildingTitle: string = '';
 showIntro: boolean = false;
 urlSwitcher: string = '';
 ifThree: boolean = false;
 sehelUser: string = '';
 postData: any = {};
 flatId: string = '';
 buildId: string = '';
 // @HostBinding('slideRight')
 @HostListener('@slideRight.done', ['$event']) doneDrawerHandler(event: any): void {
   this.showComponents = true;
 }
 @HostBinding('class.move-building-menu-half') moveBuildingMenuHalf: boolean = false;

 item: any;
 compId: any;
 user: any;
 proj: any;
 projUid: any;
 flagIfListenerOpenFake3dExist: number = 0;
 routeParams = {};
 compositeDesign: boolean = false;
 unika: boolean = false;
 showFlatProperties: boolean = false;
 @ViewChild('cmp')
 childFlatProperties: FlatPropertiesTestComponent;
 compTitle:string = '';
 @ViewChild('howMuchRooms') 
 howMuchRoomsChild: HowMuchRoomsComponent;
 @ViewChild('three')
 threeJs: ThreejsComponent;
 @ViewChild('rose')
 rose: WindRoseComponent;
 showFilters: boolean = true;

 constructor(
   public dataService: DataService,
   private route: ActivatedRoute,
   private titleService: Title,
   private router: Router,
   private location: Location
 ) {
   this.compId = this.route.snapshot.params.id;
   this.projUid = this.route.snapshot.params.idp;
  //  this.flatId = this.route.snapshot.params.flatId;
  //  this.buildId = this.route.snapshot.params.buid;
   this.sehelUser = this.route.snapshot.params.seheluser;
   this.postData.clientId = this.route.snapshot.params.seheluser;
 }

 ngOnInit(): void {
   this.urlSwitcher = this.dataService.wichDesign().urlSwitcher;
   this.compositeDesign = this.dataService.wichDesign().compositeDesign;
   this.unika = this.dataService.wichDesign().unika;
   switch (window.location.host) {
     case 'spirical.net':
       this.compTitle = 'Spirikal';
       break;
     case 'spirical-maps.firebaseapp.com':
         this.compTitle = 'Spirikal';
         break;
     case 'localhost:4200':
           this.compTitle = 'Spirikal';
           break;
     default:
   }
   window.addEventListener("message", this.receiveMessage.bind(this), false);
   if (window.innerWidth < 1200) {
     this.desktopResolution = false;
   }
   if (this.route.snapshot.queryParams.m === 'all') {
     this.removeCloseButton = true;
   }
   this.isItFlatF();
   this.isItBuildingMobileF()
   this.router.events.subscribe((val) => {
     this.isItFlatF();
     this.isItBuildingMobileF()
   });
   this.routeParams = this.route.snapshot.params;
   // if(this.route.snapshot.params.buid && !this.route.snapshot.params.buid.includes("_")) {
     if(!this.route.snapshot.params.buid && !this.route.snapshot.params.flatId){
       this.showIntro = true;
     }
   if (this.route.snapshot.params.buid) {
     this.showBuilding = true;
     this.dataService.getSpecBuilding(this.route.snapshot.params.buid).subscribe(building => {
       this.withBuilding = building[0]?.withBuilding;
       this.buildingTitle = building[0]?.name;
     });
   }
   // this.compositeDesign = this.dataService.compositeDesign();
   let counter = 0;
   if (counter === 0) {
     // this.route.url.subscribe(segment => {
     //   if (segment.length > 3) {
     //     this.isItFlatF();
     //     for (let i = 0; segment.length > i; i++) {
     //       if (segment[i].path === 'n') {
     //         this.compositeDesign = true;
     //         // const isFlat = this.isItFlatF();
     //       } else if (segment[i].path === 'u') {
     //         this.compositeDesign = true;
     //         this.unika = true;
     //       }
     //     }
     //   }
     // })
     counter++;
   }
   this.dataService.getSpecProject(this.projUid).subscribe(proj => {
     if (proj.length > 0) {
      sessionStorage.setItem('sehelProjId', proj[0].sehelProjId);
       this.proj = proj;
       this.titleService.setTitle(this.compTitle + '-' + this.proj[0].companyTitle + ' - ' + this.proj[0].title);
       // this.titleService.setTitle('spirikal' + ' - ' + this.proj[0].title);
       if (this.proj[0].public === false) {
         this.showProject = false;
       }
     }

     // get first building to composite design if no building Id in url
     if (this.route.snapshot.params.buid === undefined && this.compositeDesign) {
       // if (this.desktopResolution) {
       //   this.dataService.getItemsByProjId(this.proj[0].id).subscribe(buildList => {
       //     let path;
       //     buildList = buildList.filter(building => building.withBuilding === true);
       //     if (buildList.length > 0) {
       //       path = '/company/n/' + this.compId + '/' + this.projUid + '/building/' + buildList[0].uid;
       //       // this.reloadCurrentRoute(path);
       //     }
       //     else {
       //       // path = '/company/n/' + this.compId + '/' + this.projUid;
       //       // window.location.reload();
       //       // this.reloadCurrentRoute(path);
       //     }
       //   });
       // }
       this.showBuilding = false;
     }
   });
   if (this.desktopResolution) {
     this.location.onUrlChange(path => {
       const pathname = path.split('/');
       if (pathname.length === 8 && this.childFlatProperties) {
         this.showFlatProperties = true;
         this.childFlatProperties.flatId = pathname[7]
         this.childFlatProperties.projUid = this.route.snapshot.params.buid
         this.childFlatProperties.ngOnInit();
       } else if(this.sehelUser && this.childFlatProperties){
        this.showFlatProperties = true;
        this.childFlatProperties.flatId = pathname[9]
        this.childFlatProperties.ngOnInit();
       }
     })
   }
   this.dataService.curBuilding.subscribe(item => {
     if(item){
       this.buildingTitle = item.name;
       console.log(this.buildingTitle);
       this.resetFilters();
     }
   })
   
   if ((this.sehelUser && !sessionStorage.getItem('user-init')) || this.sehelUser !== sessionStorage.getItem('user-init')) {
    setTimeout(() => {
      sessionStorage.setItem('user-init', this.sehelUser)
      this.postData.action = 'INIT';
      this.dataService.postSehel('setAction', this.postData);
    }, 1000);
  }
 }
 activateRoseF() {
   this.activateRose = false;
   setTimeout(() => {
   //  this.rose.activateRoseF();
   this.activateRose = true;
   }, 500);
 }

 goToNewVersion() {
   this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp")]).then(() => {
     window.location.reload();
   });
 }
 closeFlatProperties(event) {
   this.showFlatProperties = false;
   // const url = '/company/n/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid');
 
   // this.router.createUrlTree([], {relativeTo: flat.id, queryParams: {param: 6}}).toString()
   // this.location.go(url);
   // this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get('id') + '/' + this.route.snapshot.paramMap.get('idp') + '/building/' + this.route.snapshot.paramMap.get('buid')]);
   
   this.router.navigate([this.urlSwitcher + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/seheluser/' + this.sehelUser + '/building/' + this.route.snapshot.paramMap.get("buid")]);

   // if (this.compositeDesign && !this.unika) {
   //   this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid")]);
   // }  else if (this.unika) {
   //   this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.route.snapshot.paramMap.get("buid")]);
   // }
 }
 reloadCurrentRoute(path) {
   let currentUrl = path;
   this.router.routeReuseStrategy.shouldReuseRoute = () => false;
   this.router.onSameUrlNavigation = 'reload';
   this.router.navigate([currentUrl]);
 }
 // hideBuildingMenu() {
 //   this.moveBuildingMenuHalf = true;
 // }
 moveBuildinMenuFalse(size) {
   if (size === 'full') {
   } else {
     this.moveBuildingMenuHalf = false;
   }
 }
 moveBuildinMenu(size) {
   if(!this.unika){
     if (size === 'full') {
       this.moveBuildingMenuFull = !this.moveBuildingMenuFull;
     } else {
       if (!this.moveBuildingMenuHalf) {
         setTimeout(() => {
           this.moveBuildingMenuHalf = true;
         }, 2250);
       }
     }
   }
 }

 isItFlatF() {
   if (this.route.snapshot.params.flatId) {
     this.showFlatProperties = true;
   } else {
     this.showFlatProperties = false;
   }
 }
 isItBuildingMobileF() {
   if (!this.desktopResolution) {
     if (this.route.snapshot.params.buid) {
       this.showBuildings = true;
     } else {
       this.showBuildings = false;
       this.showBuilding = false;
     }
   } else {
     this.showBuildings = false;
   }
 }
 currentRoomAmountF($event) {
   this.dataService.saveNumRoomsFilter($event);
   this.currentRoomAmount = $event;
 }
 flatStatusClassF($event) {
   this.flatStatusClass = $event;
   this.dataService.saveFlatStatusClass($event);
 }
 floorsNumbersF($event) {
   // this.dataService.saveFloorsNumbers($event);
 }

 currentBuildingF($event) {
   if(this.threeJs){
     this.threeJs.reset(event);
     this.threeJs.setBuildingZoom();
   }
   if($event.hdr) {
     this.ifThree = true;
   } else {
     this.ifThree = false;
   }
   this.currentBuilding = $event;
   this.dataService.curBuilding.subscribe(item => {
     this.currentBuilding = item;
   })
   this.ifThree;
   // this.howMuchRoomsChild.ngOnInit();
 }
 resetFilters(){
   // this.dataService.curBuilding.subscribe(item => {
   //   this.currentBuilding = item;
   // })
   this.refresh = false;
   setTimeout(() => {
     this.refresh  = true;
   }, 1);
 }
 projPassFromMenu(proj) {
   this.proj = proj;
 }
 openFake3d() {
   let fake3dGallery = document.getElementsByClassName('slogan-img-project-right-down')[0];
   let addBlurElement = document.getElementsByClassName('da-iframe')[0];
   if (fake3dGallery) {
     let htmls = fake3dGallery.getElementsByClassName('htmls')[0];
     let flagIfListenerExist = 0;
     htmls.addEventListener("click", function () {
       fake3d.className += ' active';
       addBlurElement.classList.add('to-blur');
     });
     let fake3d = fake3dGallery.getElementsByClassName('iframes')[0];
     let elChild = document.createElement('a');
     fake3d.prepend(elChild);
     elChild.setAttribute('class', 'pClose 3delement-close active');
     elChild.addEventListener("click", function () {
       fake3d.classList.remove('active');
       addBlurElement.classList.remove('to-blur');
     });
     if (this.flagIfListenerOpenFake3dExist == 0) {
       fake3d.className += ' active';
       addBlurElement.classList.add('to-blur');
     }
   }
   ++this.flagIfListenerOpenFake3dExist;
 }


 receiveMessage(event) {
   if (event.origin !== 'https://topeye.club/spherikal') {
     this.message = event.data;
     console.log(this.message);
     if (this.message.length > 0 && !this.message.includes("_") && typeof(this.message) !== 'object') {
       // if (this.compositeDesign && !this.unika) {
       //   this.router.navigate(['/company/n/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.message]);
       // }  else
           if (this.unika) {
         this.router.navigate(['/company/u/' + this.route.snapshot.paramMap.get("id") + '/' + this.route.snapshot.paramMap.get("idp") + '/building/' + this.message]);
       }
     } else if (typeof(this.message) === 'string'){
       if (this.message.includes("scene_")) {
         this.curSceneName = this.message;
       }
     } else if(typeof(this.message) === 'object'){
       this.sceneTitleArray = this.message;
     }
   }
 }

}
